import React from 'react'
import PropTypes from 'prop-types'
import { connect as formikConnect, getIn } from 'formik'
import FieldGroup from './FieldGroup';

// TODO: add prop types
@formikConnect
class FormGroup extends React.Component {

	static propTypes = {
		collapsible: PropTypes.bool,
		collapsed: PropTypes.bool,
	};

	static defaultProps = {
		collapsible: false,
		collapsed: true,
	};

	constructor(props) {
		super(props)
		this.state = {
			collapsed: props.collapsed,
		}
	}

	getGroupErrors() {
		const { formik, fields } = this.props;

		const fieldNames = fields.map(field => field.name);
		const errors = {}

		for(var name of fieldNames) {
			const error = getIn(formik.errors, name);
			const touched = getIn(formik.touched, name);
			if(error && touched)
				errors[name] = error;
		}

		return Object.keys(errors).length ? errors : false;
	}

	handleHeaderClick() {
		this.setState({
			collapsed: !this.state.collapsed
		})	
	}

	get collapsedText() {
		const { fields } = this.props;
		return fields.reduce((str, field, idx) => {
			if(field.label) {
				const divider = (idx+1) === fields.length ? ' and ': ', ';
				str += (str.length ? divider : '')+field.label;
			}
			return str;
		}, '')
	}

	render() {
		const { 
			fields, 
			isEditing, 
			isNew,
			label, 
			children,
			collapsible,
		} = this.props;

		const {
			collapsed
		} = this.state;

		const groupErrors = collapsible ? this.getGroupErrors() : false;
		const text = collapsible && collapsed ? this.collapsedText : this.props.text;

		return (
			<div className="FormGroup" data-collapsible={collapsible} data-collapsed={collapsed}>
				<header className="FormGroup-header" onClick={collapsible ? ::this.handleHeaderClick : undefined}>
					<div className="FormGroup-titleWrap">
						<h2 className="FormGroup-title">{label}</h2>
						{ text &&
							<span className="FormGroup-text">{text}</span>
						}
					</div>
					{ collapsible && groupErrors &&
						<span className="FormGroup-error">Errors found in group</span>
					}
				</header>

				<div className="FormGroup-fields">

					{
						children
						? typeof children === 'function' ? children(this.props) : children
						: fields.map((fieldProps, i) => 
								<FieldGroup 
									key={fieldProps.name} 
									isEditing={isEditing}
									isNew={isNew}
									{...fieldProps}  
								/>
							)
					}
				</div>

			</div>
		)
	}
}

export default FormGroup;


// WEBPACK FOOTER //
// ./src/modules/form/components/FormGroup.jsx